export default __webpack_public_path__ + "static/media/gs.905f7210.jpg";